module.exports = __webpack_public_path__ + "img/20.8e463954.png";